import PrivateLayout from './PrivateLayout';
import BlankLayout from './BlankLayout';

export {
    PrivateLayout,
    BlankLayout
};




// WEBPACK FOOTER //
// ./src/components/layouts/index.js